import { FormLayout, InlineStack, Modal, Spinner } from "@shopify/polaris";
import Search from "../Common/Search";
import ProductTable from "../Products/ProductTable";

const AddProductModal = ({
  showModal,
  handleCloseModal,
  searchProduct,
  isSearching,
  selectedProducts,
  products,
  setProductPage,
  productPage,
  handleProductSelection,
}) => {
  return (
    <Modal
      open={showModal}
      onClose={handleCloseModal}
      title="Select Products"
      primaryAction={{
        content: "Done",
        onAction: handleCloseModal,
      }}
    >
      <Modal.Section>
        <FormLayout>
          <Search onSearch={searchProduct} />
          {isSearching && (
            <InlineStack align="center">
              <Spinner />
            </InlineStack>
          )}
          {!isSearching && (
            <ProductTable
              selectedProducts={selectedProducts}
              setSelectedProducts={handleProductSelection}
              products={products}
              setCurrentPage={setProductPage}
              currentPage={productPage}
            />
          )}
        </FormLayout>
      </Modal.Section>
    </Modal>
  );
};

export default AddProductModal;
